/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptions interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptions(value) {
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptionsFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Envs': json['Envs'] == null ? undefined : json['Envs'],
        'Web': json['Web'] == null ? undefined : json['Web'],
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptionsToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Envs': value['Envs'],
        'Web': value['Web'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptions.js.map